import React from 'react';
import styles from './DropOffHistory.module.scss';
import { Container, Row } from 'reactstrap';
import FilterInTable from '../../../../views/Manage/FilterInTable';
import DataTable from 'react-data-table-component';

const data = [
    {
        id: 1,
        date: '19/06/2024',
        time: '10:00 am',
        warehouse: 'Warehouse A, Islamabad',
        status: 'Completed',
    },
    {
        id: 2,
        date: '19/06/2024',
        time: '10:00 am',
        warehouse: 'Warehouse A, Islamabad',
        status: 'Completed',
    },
    {
        id: 3,
        date: '19/06/2024',
        time: '10:00 am',
        warehouse: 'Warehouse A, Islamabad',
        status: 'Completed',
    },
    {
        id: 4,
        date: '19/06/2024',
        time: '10:00 am',
        warehouse: 'Warehouse A, Islamabad',
        status: 'Completed',
    },
];

const columns = [
    {
        name: 'Date',
        selector: (row) => row.date,
        sortable: true,
    },
    {
        name: 'Time',
        selector: (row) => row.time,
        sortable: true,
    },
    {
        name: 'Warehouse',
        selector: (row) => row.warehouse,
        sortable: true,
        grow: 2,
    },
    {
        name: 'Status',
        selector: (row) => row.status,
        sortable: true,
    },
];

const customStyles = {
    headRow: {
        style: {
            backgroundColor: '#F2F2F2',
            color: '#1A2425',
            fontSize: '16px',
            fontWeight: '600',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "40px",
            paddingRight: "40px",
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '12px 40px',
        },
    },
};

const DropOffHistory = () => {
    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Drop off History</h4>
            <Container fluid className={styles.scheduleContainer}>
                <Row className={styles.scheduleRow}>
                    <FilterInTable componentName={"Dropoffs"} />
                    <div className={styles.table}>
                        <DataTable
                            columns={columns}
                            data={data}
                            pagination
                            highlightOnHover
                            customStyles={customStyles}
                        />
                    </div>
                </Row>
            </Container>
        </div>
    )
}

export default DropOffHistory;